<template>
	<div class="card">
		<Chart type="bar" :data="chartData" :options="chartOptions" class="h-[30rem]" />
		<div class="flex justify-center items-center text-gray-500">
			Gameweeks
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import Chart from "primevue/chart";

const props = defineProps({
	data: {
		type: Array,
		default: () => [],
	},
});

const chartData = ref({});
const chartOptions = ref({});

onMounted(() => {
	chartOptions.value = setChartOptions();
});

const setChartData = (data) => {
	const documentStyle = getComputedStyle(document.documentElement);

	return {
		labels: data.map((item) => item.week_number),
		datasets: [
			{
				label: "Entries",
				backgroundColor: 'blue',
				borderColor: documentStyle.getPropertyValue('--p-cyan-500'),
				data: data.map((item) => item.total_bets),
				maxBarThickness: 80,
				borderRadius: 2,
			},
		],
	};
};

watch(
	() => props.data,
	(newVal) => {
		if (newVal && newVal.length > 0) {
			chartData.value = setChartData(newVal);
		}
	},
	{ immediate: true, deep: true }
);


const setChartOptions = () => {
	const documentStyle = getComputedStyle(document.documentElement);
	const textColor = documentStyle.getPropertyValue("--p-text-color") || "#374151";
	const textColorSecondary = documentStyle.getPropertyValue("--p-text-muted-color") || "#9ca3af";
	const surfaceBorder = documentStyle.getPropertyValue("--p-content-border-color") || "#e5e7eb";

	return {
		maintainAspectRatio: false,
		plugins: {
			legend: {
				labels: { color: textColor },
			},
		},
		scales: {
			x: {
				ticks: { color: textColorSecondary, font: { weight: 500 } },
				grid: { display: false, drawBorder: false },
			},
			y: {
				ticks: { color: textColorSecondary },
				grid: { color: surfaceBorder, drawBorder: false },
			},
		},
	};
};
</script>
